import {Round} from '../resources/Round';
import {DomainEvent} from './DomainEvent';

export abstract class RoundEvent extends DomainEvent<Round> {}
